import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "components__rec-rich-text" }
const _hoisted_2 = ["innerHTML"]

import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-rich-text',
  props: {...recProps()},
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", {
      class: "rich-text-content",
      innerHTML: _ctx.description.content
    }, null, 8, _hoisted_2)
  ]))
}
}

})